import { useEffect, useState } from 'react';

import { MunicipioIbge } from '../../pages/fornecedor/Adm/types';
import { getAllMunicipiosIbge } from '../fornecedoresDAF/fornecedorService';

let municipiosIbgeCache: MunicipioIbge[] | null = null;

export function getMunicipiosIbgeMemoryCache() {
  return municipiosIbgeCache;
}

export function setMunicipiosIbgeMemoryCache(data: MunicipioIbge[]) {
  municipiosIbgeCache = data;
}

export function clearMunicipiosIbgeMemoryCache() {
  municipiosIbgeCache = null;
}

export function useMunicipiosIbgeCache() {
  const [data, setData] = useState<MunicipioIbge[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const cached = getMunicipiosIbgeMemoryCache();
    if (cached) {
      setData(cached);
      return;
    }

    setLoading(true);
    getAllMunicipiosIbge()
      .then((result) => {
        setData(result);
        setMunicipiosIbgeMemoryCache(result);
      })
      .finally(() => setLoading(false));
  }, []);

  return { data, loading };
}
